import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { LocationsDTO } from 'models'

interface FormAgentInterface {
    input?: InputBuildProps
    select?: SelectBuildProps
    layout: LayoutProps
}

const options = (location: LocationsDTO[]): FormAgentInterface[] => [
    {
        input: {
            id: 'codigo',
            label: 'Código do DETRAN',
            inputMode: 'text',
            type: 'text',
            required: true,
            maxLength: 12,
            onKeyDown: (e: any) =>
                [';', '+', '-', '.', ',', '='].includes(e.key) &&
                e.preventDefault(),
            onKeyUp: () => ({})
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        select: {
            id: 'uf',
            label: 'UF Detran',
            required: true,
            optionsType: 'uf'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'razaoSocial',
            label: 'Razão Social',
            required: true,
            maxLength: 64
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'cnpj',
            label: 'CNPJ',
            required: true,
            maskReplace: 'cnpj',
            inputMode: 'numeric'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        select: {
            id: 'categorizacao',
            label: 'Categorização',
            optionsType: 'agenteCategorizacao',
            required: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'email',
            label: 'Email',
            required: false
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'telefone',
            label: 'Telefone',
            maskReplace: 'contato',
            required: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 5 }
        }
    },
    {
        input: {
            id: 'cep',
            label: 'CEP',
            maskReplace: 'cep',
            inputMode: 'numeric',
            required: true,

            maxLength: 9
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 5 }
        }
    },
    {
        select: {
            id: 'ufEndereco',
            label: 'UF',
            required: true,
            isSearching: true,
            optionsType: 'uf',
            isDisable: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 2 }
        }
    },
    {
        select: {
            id: 'municipio',
            label: 'Município',
            options: location?.map(({ municipio, codigoTomDetran }) => ({
                text: municipio,
                value: `${String(codigoTomDetran)}|${municipio}`
            })),
            required: true,
            isDisable: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'logradouro',
            label: 'Logradouro',
            required: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'bairro',
            label: 'Bairro',
            required: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'numeroEndereco',
            label: 'Número',
            required: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'complemento',
            label: 'Complemento ou referência'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },

    {
        input: {
            id: 'dataInicioVigencia',
            label: 'Inicio Vigência',
            placeholder: 'dd/mm/aaaa',
            type: 'date'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'dataFimVigencia',
            label: 'Fim Vigência',
            placeholder: 'dd/mm/aaaa',
            type: 'date'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    }
]

export const FormAgents = (
    uf: string,
    location: LocationsDTO[]
): FormAgentInterface[] => {
    const isRJ = uf === 'RJ'

    const listOptions = options(location)

    if (!isRJ) return listOptions
    return [
        ...listOptions,
        {
            select: {
                id: 'instituicaoPagaTaxa',
                label: 'Instituição paga a taxa?',
                optionsType: 'booleanType',
                defaultValue: 'NAO',
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 6 }
            }
        },
        {
            input: {
                id: 'expectativaRegistroContratoDiario',
                label: 'Alerta de estoque mínimo',
                required: true,
                inputMode: 'numeric',
                onInput: (e: any) =>
                    (e.target.value = e.target.value.replace(/[^\d]/g, '')),
                maxLength: 9
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 6 }
            }
        }
    ]
}
